export default __webpack_public_path__ + "static/media/onboard_check_green.33628607.svg";